import axios from '@/api/config';

const userCertificate = {
  getUserCertificateById(data) {
    return axios.get(`${process.env.BASE_URL}/userCertificate/getUserCertificateById/` + data, {});
  },
  getUserCertificateDetail(data) {
    return axios.get(`${process.env.BASE_URL}/userCertificate/getUserCertificateDetail`, {params: data});
  },
  getUserCertificate(data) {
    return axios.get(`${process.env.BASE_URL}/userCertificate/getUserCertificate`, {params: data});
  },
  getUserCertificateList(data) {
    return axios.get(`${process.env.BASE_URL}/userCertificate/getUserCertificateList`, {params: data});
  },
  getUserCertificateTree(data) {
    return axios.get(`${process.env.BASE_URL}/userCertificate/getUserCertificateTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/userCertificate/pageList`, data);
  },
  addUserCertificate(data) {
    return axios.post(`${process.env.BASE_URL}/userCertificate/addUserCertificate`, data);
  },
  updateUserCertificate(data) {
    return axios.put(`${process.env.BASE_URL}/userCertificate/updateUserCertificate`, data);
  },
  deleteUserCertificate(data) {
    return axios.delete(`${process.env.BASE_URL}/userCertificate/deleteUserCertificate`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/userCertificate/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/userCertificate/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/userCertificate/active`, data);
  },
}

export default userCertificate;



// WEBPACK FOOTER //
// ./src/api/userCertificate.js